import { prepareRichTextForDisplay } from "../../../components/RichTextEditor/rich-text-html.ts"

const PARAGRAPH_BREAK = /<\/p>/gi
const LINE_BREAK = /<\/li>|<br\s*\/?>/gi
const TAG = /<[^>]*>/g

/** A readable plain-text rendering of a template body's HTML — for pasting
 * into a plain-text-only target, or as the `text/plain` half of a rich
 * clipboard write. A paragraph becomes a blank line (matching how it reads
 * visually); a list item or an explicit line break becomes a single one.
 * Regex replace on the markup itself, not a DOM walk — inserting text nodes
 * next to every block element double-counts wherever two of them are
 * adjacent, since both the departing element's own inserted break and its
 * neighbor's closing tag would otherwise land back to back. Decoding
 * entities is left to the browser: assigning the remaining markup (already
 * tag-free) to a detached element's `innerHTML` and reading `textContent`
 * back out. An inline image contributes nothing to the text since it has
 * none. */
const htmlToPlainText = (html?: string | null): string => {
  const withBreaks = prepareRichTextForDisplay(html)
    .replace(PARAGRAPH_BREAK, "\n\n")
    .replace(LINE_BREAK, "\n")
    .replace(TAG, "")
  const container = document.createElement("div")
  container.innerHTML = withBreaks
  return (container.textContent ?? "").replace(/\n{3,}/g, "\n\n").trim()
}

export { htmlToPlainText }
